export default __webpack_public_path__ + "static/media/icon_chevron_hub_left.492d23a8.svg";